<template>
  <div class="col-9">
    <div class="px-4 text-center my-4 border-bottom">
      <h5 class="fw-bold">მომხმარებლის პაროლი</h5>
      <p class="text-secondary small mb-4">შეცვალეთ ძველი პაროლი ახლით</p>
    </div>
    <div class="w-75 mx-auto mb-5">
      <form @submit.prevent="handleSubmit" novalidate>
        <div class="mb-4 position-relative">
          <label class="form-label fw-bold">ძველი პაროლი</label>
          <input
            :type="showPassword ? 'text' : 'password'"
            class="form-control"
            :class="{ 'is-invalid': oldPasswordError }"
            v-model="oldPassword"
            @focus="oldPasswordError = false"
          />
          <div class="show-password" @click="showPassword = !showPassword">
            <span v-if="!showPassword" class="material-icons text-secondary">
              visibility
            </span>
            <span v-if="showPassword" class="material-icons text-secondary">
              visibility_off
            </span>
          </div>
          <div v-if="oldPasswordError" class="invalid-feedback">
            {{ oldPasswordErrorMessage }}
          </div>
        </div>
        <div class="mb-4 position-relative">
          <label class="form-label fw-bold">პაროლი</label>
          <input
            :type="showPassword ? 'text' : 'password'"
            class="form-control"
            :class="{ 'is-invalid': passwordError }"
            v-model="password"
            @focus="passwordError = false"
          />
          <div v-if="passwordError" class="invalid-feedback">
            {{ passwordErrorMessage }}
          </div>
        </div>
        <div class="mb-4 position-relative">
          <label class="form-label fw-bold">გაიმეორეთ პაროლი</label>
          <input
            :type="showPassword ? 'text' : 'password'"
            class="form-control"
            :class="{ 'is-invalid': passwordConfirmError }"
            v-model="passwordConfirm"
            @focus="passwordConfirmError = false"
          />
          <div v-if="passwordConfirmError" class="invalid-feedback">
            {{ passwordConfirmErrorMessage }}
          </div>
        </div>
        <div
          v-if="serverError"
          class="alert alert-danger mb-3 text-center"
          role="alert"
        >
          {{ serverErrorMessage }}
        </div>
        <div
          v-if="serverSuccess"
          class="alert alert-success mb-3 text-center"
          role="alert"
        >
          {{ serverSuccessMessage }}
        </div>
        <div class="text-center">
          <button
            type="submit"
            class="btn btn-primary rounded-pill px-4 font-caps"
          >
            შეცვლა
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";

export default {
  props: ["store"],
  setup(props) {
    const oldPassword = ref("");
    const password = ref("");
    const passwordConfirm = ref("");

    const oldPasswordError = ref(false);
    const oldPasswordErrorMessage = ref("");
    const passwordError = ref(false);
    const passwordErrorMessage = ref("");
    const passwordConfirmError = ref(false);
    const passwordConfirmErrorMessage = ref("");
    const serverError = ref(false);
    const serverErrorMessage = ref("");
    const serverSuccess = ref(false);
    const serverSuccessMessage = ref("");

    const showPassword = ref(false);

    const handleSubmit = async () => {
      serverSuccess.value = false;
      serverError.value = false;

      if (oldPassword.value.length < 6) {
        oldPasswordError.value = true;
        oldPasswordErrorMessage.value =
          "ძველი პაროლი მინიმუმ უნდა შეიცავდეს 6 სიმბოლოს";
      }

      if (password.value.length < 6) {
        passwordError.value = true;
        passwordErrorMessage.value = "პაროლი მინიმუმ უნდა შეიცავდეს 6 სიმბოლოს";
      }

      if (passwordConfirm.value.length === 0) {
        passwordConfirmError.value = true;
        passwordConfirmErrorMessage.value =
          "განმეორებითი პაროლის ველი ცარიელია";
      } else if (passwordConfirm.value !== password.value) {
        passwordConfirmError.value = true;
        passwordConfirmErrorMessage.value =
          "განმეორებითი პაროლი არ ემთხვევა პაროლს";
      }

      if (
        !oldPasswordError.value &&
        !passwordError.value &&
        !passwordConfirmError.value
      ) {
        try {
          await props.store.dispatch("updateUserPassword", {
            oldPassword: oldPassword.value,
            password: password.value,
            passwordConfirm: passwordConfirm.value,
          });

          serverSuccess.value = true;
          serverSuccessMessage.value = "პაროლი შეიცვალა";

          oldPassword.value = "";
          password.value = "";
          passwordConfirm.value = "";
        } catch (error) {
          serverError.value = true;
          serverErrorMessage.value = error.message;
        }
      } else {
        serverError.value = false;
      }
    };

    return {
      oldPassword,
      password,
      passwordConfirm,
      oldPasswordError,
      oldPasswordErrorMessage,
      passwordError,
      passwordErrorMessage,
      passwordConfirmError,
      passwordConfirmErrorMessage,
      serverError,
      serverErrorMessage,
      serverSuccess,
      serverSuccessMessage,
      showPassword,
      handleSubmit,
    };
  },
};
</script>

<style>
</style>